const webAddress = "getventix.com"
const env = process.env.REACT_APP_ENV

const sharedConfigs = {
  appName: "Ventix",
  isDev: false,
  isStg: false,
  isProd: false,
  afrimnoneyCode: "*3661*7*4",
  // apiHostname: "http://10.0.0.19:8080",
  apiHostname: "http://localhost:8080",
  // feHostname: "http://10.0.0.105:3000",
  feHostname: "http://localhost:3000",
  shareHostname: "https://share.getventix.com",
  omslNumberLength: 10,
}

const configs = {
  dev: {
    ...sharedConfigs,
    ...{
      isDev: true,
    },
  },
  stg: {
    ...sharedConfigs,
    ...{
      isStg: true,
      apiHostname: `https://stg-api.${webAddress}`,
      feHostname: `https://stg.${webAddress}`,
    },
  },
  prod: {
    ...sharedConfigs,
    ...{
      isProd: true,
      apiHostname: `https://api.${webAddress}`,
      feHostname: `https://${webAddress}`,
      omslNumberLength: 9,
      afrimnoneyCode: "*161*7*2",
    },
  },
}

export const appConfigs = configs[env]
